<!-- 臨時公告 -->
<template lang="pug">
.announcementModal(
  v-if="shouldShow"
)
  .announcementModal__popup
    h3.announcementModal__title 重要公告
    .announcementModal__content
      p.announcementModal__text 提醒您！
      p.announcementModal__text 12/6 - 12/7 因應高雄世運會實施道路管制，部分路段不提供上下車。
    .announcementModal__radioWrapper(
      @click="toggleCheckRead"
    )
      RadioCheckedUI.announcementModal__radio(
        :isChecked="isChecked"
      )
      p.announcementModal__radioText 我知道了
    .announcementModal__btnWrapper
      BaseBtnConfirm(
        :text="'確定'"
        :disabled="!isChecked"
        @click="handleConfirm"
      )
</template>

<script>
import RadioCheckedUI from '@/components/common/RadioCheckedUI'
import BaseBtnConfirm from '@/components/BaseComponent/BaseBtnConfirm'
import moment from 'moment'

export default {
  name: 'AnnouncementModal',
  data() {
    return {
      isChecked: false,
      shouldShow: false,
      // 公告顯示時間設定
      announcementStartTime: '2025-12-05 23:30:00', // 開始時間
      announcementEndTime: '2025-12-08 00:00:00', // 結束時間）
    }
  },
  components: {
    RadioCheckedUI,
    BaseBtnConfirm,
  },
  mounted() {
    this.checkTimeRange()
    // 監聽手動顯示公告的事件
    this.$root.$on('showAnnouncement', this.forceShow)
  },
  beforeDestroy() {
    // 移除事件監聽
    this.$root.$off('showAnnouncement', this.forceShow)
  },
  methods: {
    checkTimeRange() {
      // 設定公告顯示的時間範圍
      const startTime = moment(
        this.announcementStartTime,
        'YYYY-MM-DD HH:mm:ss'
      )
      const endTime = moment(this.announcementEndTime, 'YYYY-MM-DD HH:mm:ss')
      // 當前時間
      const now = moment()

      // 只有在時間範圍內才顯示公告
      // 使用 isSameOrAfter 和 isSameOrBefore 來包含邊界時間
      if (
        (now.isAfter(startTime) || now.isSame(startTime)) &&
        (now.isBefore(endTime) || now.isSame(endTime))
      ) {
        this.shouldShow = true
      } else {
        this.shouldShow = false
      }
    },
    toggleCheckRead() {
      this.isChecked = !this.isChecked
    },
    handleConfirm() {
      // 必須勾選「我知道了」才能關閉
      if (!this.isChecked) {
        return
      }
      // 勾選「我知道了」只是讓這次可以關閉，不儲存狀態
      // 下次開啟時還是會顯示公告
      this.shouldShow = false
      // 重置 checkbox 狀態，下次顯示時是未勾選狀態
      this.isChecked = false
    },
    forceShow() {
      // 強制顯示公告（不檢查時間範圍）
      this.shouldShow = true
      this.isChecked = false
    },
  },
}
</script>

<style lang="scss" scoped>
.announcementModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  &__popup {
    width: 296px;
    min-height: 208px;
    border-radius: 20px;
    background-color: #ffffff;
    padding-top: 24px;
    padding-bottom: 8px;
    box-sizing: border-box;
  }

  &__title {
    margin: 0;
    padding: 0 20px;
    padding-bottom: 16px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
  }

  &__content {
    padding: 0 20px;
    margin-bottom: 8px;
  }

  &__text {
    margin: 0;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
  }

  &__radioWrapper {
    margin-top: 16px;
    padding: 0 8px;
    height: 56px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__radio {
    margin-left: 26px;
  }

  &__radioText {
    font-size: 14px;
    margin-left: 24px;
    color: rgba(0, 0, 0, 0.87);
  }

  &__btnWrapper {
    margin-top: 8px;
    padding: 0 16px;
  }
}
</style>
